<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑版本"></el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="来源" prop="app_source">
                <el-select v-model="ruleForm.app_source" placeholder="请选择来源" style="width: 100%;">
                    <el-option
                            v-for="item in allAppSource"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="版本号" prop="version_num">
                <el-input type="text" v-model="ruleForm.version_num" placeholder="请输入版本号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="地址配置ID（服务器）" prop="sites_id">
                <el-select v-model="ruleForm.sites_id" placeholder="请选择服务器" style="width: 100%;">
                    <el-option
                            v-for="item in allSite"
                            :key="item.id"
                            :label="item.site_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否强制安装" prop="rewrite">
                <el-radio-group v-model="ruleForm.rewrite">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否提示用户更新安装" prop="showupdate">
                <el-radio-group v-model="ruleForm.showupdate">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="小于该版本强制更新" prop="forceupdate">
                <el-input type="text" v-model="ruleForm.forceupdate" placeholder="请输入版本号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="版本更新内容" prop="update_content">
                <el-input type="textarea" v-model="ruleForm.update_content" autosize placeholder="请输入版本更新内容" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="text" v-model="ruleForm.remark" placeholder="请输入备注" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="app下载地址" prop="app_download_url">
                <el-input type="text" v-model="ruleForm.app_download_url" placeholder="请输入app下载地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>


            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        mounted() {
            this.id = this.$route.params.id;
            this.ruleForm.version_num = this.$route.params.version_num;
            this.ruleForm.version_result = this.$route.params.version_result;
            this.ruleForm.sites_id = this.$route.params.sites_id;
            this.ruleForm.app_source = this.$route.params.app_source;
            this.ruleForm.rewrite = parseInt(this.$route.params.rewrite);
            this.ruleForm.showupdate = parseInt(this.$route.params.showupdate);
            this.ruleForm.forceupdate = this.$route.params.forceupdate;
            this.ruleForm.update_content = this.$route.params.update_content;
            this.ruleForm.remark = this.$route.params.remark;
            this.ruleForm.app_download_url = this.$route.params.app_download_url;
            this.getAllRole();
        },
        data() {
            return {
                id: '',
                allAppSource: [
                    {
                        id: 1,
                        name: 'Android'
                    },
                    {
                        id: 2,
                        name: 'IOS'
                    },
                    {
                        id: 3,
                        name: 'PC网页'
                    }
                ],
                allSite: [],
                ruleForm: {
                    app_source: "",
                    version_num: "",
                    sites_id: "",
                    rewrite: 2,
                    showupdate: 0,
                    forceupdate: '',
                    update_content: '',
                    remark: '',
                    app_download_url: '',
                },
                rules: {
                    app_source: [
                        {required: true, message: "请选择版本", trigger: "blur"},
                    ],
                    version_num: [
                        {required: true, message: "请选择版本号", trigger: "blur"},
                    ],
                    forceupdate: [
                        {required: true, message: "请选择版本号", trigger: "blur"},
                    ],
                    sites_id: [
                        {required: true, message: "请选择服务器", trigger: "blur"},
                    ],
                    rewrite: [
                        {required: true, message: "请选择是否强制安装", trigger: "blur"},
                    ],
                    showupdate: [
                        {required: true, message: "请选择是否提示用户更新安装", trigger: "blur"},
                    ],
                    update_content: [
                        {required: true, message: "请输入版本更新内容", trigger: "blur"},
                    ],
                    app_download_url: [
                        {required: true, message: "请输入app下载地址", trigger: "blur"},
                    ],
                },
                is_submit: false,
            };
        },
        methods: {
            getAllRole() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'allSite',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allSite = res.data.data;
                });
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminSystemServices',
                            'method': 'editAppVersion',
                            'params': {
                                id: this.id,
                                version_num: this.ruleForm.version_num,
                                app_source: this.ruleForm.app_source,
                                sites_id: this.ruleForm.sites_id,
                                forceupdate: this.ruleForm.forceupdate,
                                update_content: this.ruleForm.update_content,
                                remark: this.ruleForm.remark,
                                app_download_url: this.ruleForm.app_download_url,
                                rewrite: this.ruleForm.rewrite,
                                showupdate: this.ruleForm.showupdate,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    window.history.go(-1);
                                }
                            });
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
                this.is_submit = false;
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }

    .avatar {
        width: 50px;
        height: 50px;
        display: block;
    }
</style>
